import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

function Profile() {
  const [userData, setUserdata] = useState(null);
  const [alluserdata, setalluserdata] = useState({});
  const [editMode, setEditMode] = useState(false); // 🔹 Track edit mode
  const [editedData, setEditedData] = useState({
    username: "",
    email: "",
    phoneNumber: "",
  });

  useEffect(() => {
    const userdata = localStorage.getItem("user");

    if (userdata) {
      try {
        const parsedUser = JSON.parse(userdata);
        setUserdata(parsedUser);
      } catch (error) {
        console.error("Error parsing user data from localStorage:", error);
      }
    } else {
      console.log("No user data found in localStorage.");
    }
  }, []);

  useEffect(() => {
    if (userData?._id) {
      getalluserdata();
    }
  }, [userData]);

  const getalluserdata = async () => {
    try {
      const response = await axios.get(
        `https://api.proleverageadmin.in/api/users/getparticularuser/${userData?._id}`
      );
      setalluserdata(response.data.data);
      setEditedData({
        username: response.data.data.username,
        email: response.data.data.email,
        phoneNumber: response.data.data.phoneNumber,
      });
    } catch (error) {
      console.log(error);
    }
  };

  // 🔹 Handle Input Changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditedData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  // 🔹 Handle Update (Send Data to Backend)
  const handleUpdate = async () => {
    try {
      const response = await axios.put(
        `https://api.proleverageadmin.in/api/users/updateuser/${userData?._id}`,
        editedData
      );

      if (response.status === 200) {
        alert("Profile updated successfully!");
        setEditMode(false);
        getalluserdata(); // Refresh user data
      }
    } catch (error) {
      console.error("Update failed:", error);
      alert("Failed to update profile");
    }
  };

  const handlelogout = () => {
    localStorage.removeItem("user");
    window.location.assign("/");
  };

  return (
    <div className="row" style={{ margin: "25px", justifyContent: "center" }}>
      <div className="col-md-4">
        <div
          className="row "
          style={{
            background: "linear-gradient(135deg, #6a11cb, #2575fc)", // Gradient background
            padding: "10px",
            borderRadius: "15px",
          }}
        >
          <div className="d-flex" style={{ justifyContent: "center" }}>
            <i
              className="fa-solid fa-circle-user"
              style={{ fontSize: "40px", color: "white", textAlign: "center" }}
            ></i>
          </div>

          {editMode ? (
            <>
              <input
                type="text"
                name="username"
                value={editedData.username}
                onChange={handleInputChange}
                className="form-control my-2"
                placeholder="Enter Name"
              />
              <input
                type="email"
                name="email"
                value={editedData.email}
                onChange={handleInputChange}
                className="form-control my-2"
                placeholder="Enter Email"
              />
              <input
                type="text"
                name="phoneNumber"
                value={editedData.phoneNumber}
                onChange={handleInputChange}
                className="form-control my-2"
                placeholder="Enter Mobile Number"
              />
            </>
          ) : (
            <>
              <div
                className="poppins-regular text-center mt-1"
                style={{ color: "white" }}
              >
                {alluserdata?.username}
              </div>
              <div
                className="poppins-regular text-center mt-1"
                style={{ color: "white" }}
              >
                {alluserdata?.email}
              </div>
              <div
                className="poppins-regular text-center mt-1"
                style={{ color: "white" }}
              >
                {alluserdata?.phoneNumber}
              </div>
            </>
          )}

          {/* 🔹 Edit and Save Buttons */}
          <div className="d-flex justify-content-center mt-3">
            {editMode ? (
              <>
                <button className="btn btn-success mx-2" onClick={handleUpdate}>
                  Save
                </button>
                <button
                  className="btn btn-danger"
                  onClick={() => setEditMode(false)}
                >
                  Cancel
                </button>
              </>
            ) : (
              <button
                className="btn-light poppins-medium"
                onClick={() => setEditMode(true)}
                style={{
                  color: "black",
                  backgroundColor: "white",
                  borderRadius: "5px",
                }}
              >
                Edit Profile
              </button>
            )}
          </div>
        </div>

        <div
          onClick={handlelogout}
          className="d-flex mt-5"
          style={{
            backgroundColor: "lightgrey",
            padding: "10px",
            borderRadius: "5px",
          }}
        >
          <div className="col-md-1">
            <i
              className="fa-solid fa-right-from-bracket"
              style={{ fontSize: "20px" }}
            ></i>
          </div>
          <div className="col-md-11">
            <div className="poppins-semibold text-center mx-3">Logout</div>
          </div>
        </div>

        <Link to="/Plans" style={{ textDecoration: "none" }}>
          <div
            className="d-flex mt-4"
            style={{
              backgroundColor: "lightgrey",
              padding: "10px",
              borderRadius: "5px",
            }}
          >
            <div className="col-md-1">
              <i
                className="fa-solid fa-money-bill"
                style={{ fontSize: "20px", color: "black" }}
              ></i>
            </div>
            <div className="col-md-11">
              <div
                className="poppins-semibold text-center mx-3"
                style={{ color: "black" }}
              >
                Subscriptions
              </div>
            </div>
          </div>
        </Link>

        <div
          className="d-flex mt-4"
          style={{
            backgroundColor: "lightgrey",
            padding: "10px",
            borderRadius: "5px",
          }}
        >
          <div className="col-md-1">
            <i
              className="fa-solid fa-money-bill"
              style={{ fontSize: "20px", color: "black" }}
            ></i>
          </div>
          <div className="col-md-11">
            <div
              className="poppins-semibold text-center mx-3"
              style={{ color: "black" }}
            >
              Payment History
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default Profile;
